import { useNavigate } from 'react-router-dom';
import { usePosAuth } from '@/contexts/PosAuthContext';
import { QrCode, Search, HandCoins, LogOut } from 'lucide-react';

const ACTIONS = [
  { to: '/pos/scanner', label: 'Scan QR', icon: QrCode, testId: 'pos-home-scan-qr' },
  { to: '/pos/search', label: 'Search Customer', icon: Search, testId: 'pos-home-search-customer' },
  { to: '/pos/pending-payments', label: 'Pending Payments', icon: HandCoins, testId: 'pos-home-pending-payments' },
];

export default function PosHome() {
  const { posStaff, lock } = usePosAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-obsidian flex flex-col items-center justify-center px-6 py-10">
      <div className="w-full max-w-md text-center mb-8">
        <p className="text-white/50 text-sm">Logged in as</p>
        <p className="font-heading text-2xl font-700 text-white" data-testid="pos-staff-name">{posStaff?.name}</p>
      </div>

      <div className="w-full max-w-md grid gap-4">
        {ACTIONS.map((a) => (
          <button
            key={a.to}
            data-testid={a.testId}
            onClick={() => navigate(a.to)}
            className="h-24 rounded-2xl bg-white/10 hover:bg-saffron/90 text-white flex items-center gap-4 px-6 transition-colors duration-150"
          >
            <a.icon size={28} />
            <span className="font-heading text-xl font-semibold">{a.label}</span>
          </button>
        ))}
      </div>

      <button
        data-testid="pos-lock-btn"
        onClick={() => {
          lock();
          navigate('/pos');
        }}
        className="mt-10 flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors duration-150"
      >
        <LogOut size={16} /> Switch User / Lock
      </button>
    </div>
  );
}
